import { ApiPost } from '../util/axios'
import { consoleLog } from '../util'

const localQuestionArray = Array(13).fill('localQuestion').map((d, i) => (d + i))

const setOrganizationAggregationQuestionApi = async (data, type) => {
  const options = {
    reqId: `SetOrganizationAggregationQuestion${type.replace('itemQuestion', '')}`,
    payload: data,
    resId: `SetOrganizationAggregationQuestion${type.replace('itemQuestion', '')}Result`,
    resType: 'object',
    getLatest: true
  }
  if (['questionMulti1', 'questionMulti2'].includes(type)) {
    options.reqId = `SetOrganizationAggregationQuestionMulti${type.replace('questionMulti', '')}`
    options.resId = `SetOrganizationAggregationQuestionMulti${type.replace('questionMulti', '')}Result`
  } else if (['globalQuestion1', 'globalQuestion2'].includes(type)) {
    options.reqId = `SetOrganizationAggregationUserGlobalQuestion${type.replace('globalQuestion', '')}`
    options.resId = `SetOrganizationAggregationUserGlobalQuestion${type.replace('globalQuestion', '')}Result`
  } else if (localQuestionArray.includes(type)) {
    options.reqId = `SetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}`
    options.resId = `SetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}Result`
  } else if (['itemSubQuestion1A', 'itemSubQuestion1B', 'itemSubQuestion3A', 'itemSubQuestion3B'].includes(type)) {
    options.reqId = `SetOrganizationAggregationQuestion${type.replace('itemSubQuestion', '')}`
    options.resId = `SetOrganizationAggregationQuestion${type.replace('itemSubQuestion', '')}Result`
  } else if (['userLocalSubQuestion1A', 'userLocalSubQuestion1B', 'userLocalSubQuestion3A', 'userLocalSubQuestion3B'].includes(type)) {
    options.reqId = `SetOrganizationAggregationUserLocalQuestion${type.replace('userLocalSubQuestion', '')}`
    options.resId = `SetOrganizationAggregationUserLocalQuestion${type.replace('userLocalSubQuestion', '')}Result`
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationQuestionApi = async (data, type) => {
  const options = {
    reqId: `GetOrganizationAggregationQuestion${type.replace('itemQuestion', '')}`,
    payload: data,
    resId: `GetOrganizationAggregationQuestion${type.replace('itemQuestion', '')}Result`,
    resType: 'object',
    getLatest: true
  }
  if (['questionMulti1', 'questionMulti2'].includes(type)) {
    options.reqId = `GetOrganizationAggregationQuestionMulti${type.replace('questionMulti', '')}`
    options.resId = `GetOrganizationAggregationQuestionMulti${type.replace('questionMulti', '')}Result`
  } else if (['globalQuestion1', 'globalQuestion2'].includes(type)) {
    options.reqId = `GetOrganizationAggregationUserGlobalQuestion${type.replace('globalQuestion', '')}`
    options.resId = `GetOrganizationAggregationUserGlobalQuestion${type.replace('globalQuestion', '')}Result`
  } else if (localQuestionArray.includes(type)) {
    options.reqId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}`
    options.resId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}Result`
  } else if (['itemSubQuestion1A', 'itemSubQuestion1B', 'itemSubQuestion3A', 'itemSubQuestion3B'].includes(type)) {
    options.reqId = `GetOrganizationAggregationQuestion${type.replace('itemSubQuestion', '')}`
    options.resId = `GetOrganizationAggregationQuestion${type.replace('itemSubQuestion', '')}Result`
  } else if (['userLocalSubQuestion1A', 'userLocalSubQuestion1B', 'userLocalSubQuestion3A', 'userLocalSubQuestion3B'].includes(type)) {
    options.reqId = `GetOrganizationAggregationUserLocalQuestion${type.replace('userLocalSubQuestion', '')}`
    options.resId = `GetOrganizationAggregationUserLocalQuestion${type.replace('userLocalSubQuestion', '')}Result`
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getItemsAnalyzedPerQuestionCountApi = async (data, type) => {
  const options = {
    reqId: `GetItemsAnalyzedPerQuestion${type.replace('itemQuestion', '')}Count`,
    payload: data,
    resId: `GetItemsAnalyzedPerQuestion${type.replace('itemQuestion', '')}CountResult`,
    resType: 'object',
    getLatest: true
  }
  if (['questionMulti1', 'questionMulti2'].includes(type)) {
    options.reqId = `GetItemsAnalyzedPerQuestionMulti${type.replace('questionMulti', '')}Count`
    options.resId = `GetItemsAnalyzedPerQuestionMulti${type.replace('questionMulti', '')}CountResult`
  } else if (['globalQuestion1', 'globalQuestion2'].includes(type)) {
    options.reqId = `GetItemsAnalyzedPerUserGlobalQuestion${type.replace('globalQuestion', '')}Count`
    options.resId = `GetItemsAnalyzedPerUserGlobalQuestion${type.replace('globalQuestion', '')}CountResult`
  } else if (localQuestionArray.includes(type)) {
    options.reqId = `GetItemsAnalyzedPerUserLocalQuestion${type.replace('localQuestion', '')}Count`
    options.resId = `GetItemsAnalyzedPerUserLocalQuestion${type.replace('localQuestion', '')}CountResult`
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationQuestion1AApi = async (data, type) => {
  const options = {
    reqId: 'GetOrganizationAggregationQuestion1A',
    payload: data,
    resId: 'GetOrganizationAggregationQuestion1AResult',
    resType: 'object',
    getLatest: true
  }
  if (['itemQuestion3'].includes(type)) {
    options.reqId = `GetOrganizationAggregationQuestion${type.replace('itemQuestion', '')}A`
    options.resId = `GetOrganizationAggregationQuestion${type.replace('itemQuestion', '')}AResult`
  } else if (['localQuestion1'].includes(type)) {
    options.reqId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}A`
    options.resId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}AResult`
  } else if (['localQuestion3'].includes(type)) {
    options.reqId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}A`
    options.resId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}AResult`
  }

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationQuestion1BApi = async (data, type) => {
  const options = {
    reqId: 'GetOrganizationAggregationQuestion1B',
    payload: data,
    resId: 'GetOrganizationAggregationQuestion1BResult',
    resType: 'object',
    getLatest: true
  }
  if (['itemQuestion3'].includes(type)) {
    options.reqId = `GetOrganizationAggregationQuestion${type.replace('itemQuestion', '')}B`
    options.resId = `GetOrganizationAggregationQuestion${type.replace('itemQuestion', '')}BResult`
  } else if (['localQuestion1'].includes(type)) {
    options.reqId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}B`
    options.resId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}BResult`
  } else if (['localQuestion3'].includes(type)) {
    options.reqId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}B`
    options.resId = `GetOrganizationAggregationUserLocalQuestion${type.replace('localQuestion', '')}BResult`
  }

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setAggregationItemSubPropertyNameValuesApi = async data => {
  const options = {
    reqId: 'SetAggregationItemSubPropertyNameValues',
    payload: data,
    resId: 'SetAggregationItemSubPropertyNameValuesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getAggregationItemSubPropertyNameValuesApi = async data => {
  const options = {
    reqId: 'GetAggregationItemSubPropertyNameValues',
    payload: data,
    resId: 'GetAggregationItemSubPropertyNameValuesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setOrganizationAggregationCopyQuestionsApi = async data => {
  const options = {
    reqId: 'SetOrganizationAggregationCopyQuestions',
    payload: data,
    resId: 'SetOrganizationAggregationCopyQuestionsResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

export default {
  setOrganizationAggregationQuestionApi,
  getOrganizationAggregationQuestionApi,
  getItemsAnalyzedPerQuestionCountApi,
  getOrganizationAggregationQuestion1AApi,
  getOrganizationAggregationQuestion1BApi,
  setAggregationItemSubPropertyNameValuesApi,
  getAggregationItemSubPropertyNameValuesApi,
  setOrganizationAggregationCopyQuestionsApi
}
